
























































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  image: string;
  comment: string;
  items: Array<string>;
  pres: Array<string>;
}

@Component
export default class OpenCVComponent extends Vue {

  @Prop()
  //el: '#radio'
  private msg!: string;
  
private text1 = `
func getframes() {
	fmt.Println("getframes() 1.開始")
	//webcam, err = gocv.OpenVideoCapture(fileName)
	webcam, err = gocv.OpenVideoCapture(0)
	if err != nil {
		fmt.Printf("Error opening capture device: \\n")
		return
	}
	defer webcam.Close()
	img := gocv.NewMat()
	defer img.Close()

	for {
	    if quitFlag == true {
	    	break
	    	//return
	    }
		if ok := webcam.Read(&img); !ok {
			fmt.Printf("Device closed\\n")
			break
			//return
		}
		if img.Empty() {
			continue
		}
		
		gocv.Resize(img, &img, image.Point{}, float64(1.5), float64(1.5), 0)

		frame, _ = gocv.IMEncode(".jpg", img)
	}
	fmt.Println("getframes() 2.終了")

}`
  
private text2 = `
  func videoHandler(w http.ResponseWriter, r *http.Request) {
	fmt.Println("videoHandler() 1.r.Method: ", r.Method)
	// 
	go getframes()
	
	w.Header().Set("Content-Type", "multipart/x-mixed-replace; boundary=frame")
	data := ""
	for {
		mutex.Lock()
		data = "--frame\\r\\n  Content-Type: image/jpeg\\r\\n\\r\\n" + string(frame) + "\\r\\n\\r\\n"
		mutex.Unlock()
		
		//time.Sleep(1 * time.Millisecond)
		time.Sleep(1000 * time.Millisecond)
		w.Write([]byte(data))
		//fmt.Println("videoHandler() 2.data: ", data)
	
	}
}`

  private contents1: Description = {
  	id: "1",
  	title: "Go言語で作成したWebサーバからストリーミング配信",
  	descriptions: [
  	 {id: "1",
  	  title: "クライアントへの送信データを用意する",
  	  //image: require("../assets/webサーバ1.png"),
  	  image: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/webサーバ1.png?alt=media",
  	  comment: "ストリーミング配信の構成（Linuxサーバは、Webサーバなら何でもよい）",
  	  items: [
  	  	"getframes()関数を用意しmain関数と並列処理させます。",
  	  	"Writeメソッドで使用される書き込みバッファとして、",
  	  	"var frame []byte",
  	  	"をグローバル変数で定義し、以下のgetframes()関数で、そのframeデータを格納します。",
  	    ],
		pres: [this.text1],
  	 }, // end of id=1
	 {id: "2",
  	  title: "videoHandler()メソッドの作成",
  	  image: "",
  	  comment: "",
  	  items: [
  	  	"Webブラウザから「https://xxx/video」でアクセスした場合のvideoHandler()メソッドを作成します。",
  	  	"このハンドラでは「go getframes()」でgetframes()関数のgoroutineを起動しておきます。",
  	  	"その後、getframes()関数が作成したframeデータを端末（Webブラウザ）に送信し続けます。",
  	    ],
		pres: [this.text2],
  	 }, // end of id=2
	 {id: "3",
  	  title: "クライアントでWebカメラを動かす",
  	  image: "",
  	  comment: "",
  	  items: [
  	  	"当然ながら、クラウド上にあるWebサーバでは、Webカメラは接続されていない。",
  	  	"このハンドラでは「go getframes()」でgetframes()関数のgoroutineを起動しておきます。",
  	  	"その後、getframes()関数が作成したframeデータを端末（Webブラウザ）に送信し続けます。",
  	    ],
		pres: [],
  	 }, // end of id=3
  	]
  }
  
  private contents2: Description = {
  	id: "1",
  	title: "尼子氏の歴史",
  	descriptions: [{
  	  id: "1",
  	  title: "広瀬の月山富田城",
  	  image: "http://www.hiroict.com/files/talkai/Pictures/トークA愛/月山富田城1.jpg",
  	  comment: "広瀬の月山富田城",
  	  items: [
  	    "飯梨川右岸、標高184mの月山の地形を利用した複郭式の山城（史跡）。",
  	    "主に尼子氏の居城として知られ、城郭は内郭、外郭から構成され、塩谷口、お子守口、菅谷口の三つの入口があり。",
  	    "周囲は断崖絶壁が多く、防衛上、軍政統治上も欠くことの出来ない立地条件を具備し、中国地方における中世城郭の代表的な城跡として重要視されていました。",
  	    "文治元年（1185年）佐々木義晴が出雲の守護として入城以来、それ以後塩冶、佐々木、山名、京極、尼子、毛利、堀尾の各氏が歴代城主として交替。",
  	    "そのなかで最も栄華を極めたのが引用11ヶ国を領有した尼子氏の時期である。慶長16年（1611年）堀尾吉晴の歿するまでの427年間、軍政上の一大拠点を築き上げていました。",
  	    "-",
  	    "現在は、往時を偲ぶ建物は一つも残っておらず、中腹の山中御殿から山頂の本丸にかけて石垣が保存されているのみ。",
  	    "当時の母屋と侍所が復元された花の壇、桜の名所である太鼓壇など一巡して約1時間。",
  	    "山頂部の七曲の登城道を登ると、西の袖平、三の丸、二の丸、本丸が連郭式に配置され、特に二の丸の周りを囲む石垣や、本丸との間の深い掘切は必見です。", 
  	  ],
  	  pres: [],

  	}]
  }
  private contents3: Description = {
  	id: "1",
  	title: "坂本龍馬の暗殺犯人",
  	descriptions: [
  	 {id: "1",
  	  title: "仏教徒の坂本龍馬はキリスト教徒に殺された",
  	  image: "http://www.hiroict.com/files/talkai/Pictures/トークA愛/近江屋古写真（国立国会図書館蔵）.jpg",
  	  comment: "近江屋古写真（国立国会図書館蔵）",
  	  items: [
  	    "織田信長は、隠れキリシタンだった明智光秀に殺されたが、仏教徒の坂本龍馬はキリスト教徒に殺された。",
  	    "具体的には、当時の英国公使のパークスや通訳のアーネストサトウの命令で殺された。",
  	    "坂本龍馬は、海援隊が出版した「閑愁録」で、あまりにもキリスト教の悪口を言い過ぎたからである。",
  	  ],
  	  pres: [],
  	 },// end of id=1
  	 {id: "2",
  	  title: "土佐藩参政の要職にあった福岡孝悌（藤次）の怪しい行動",
  	  image: "http://www.hiroict.com/files/talkai/Pictures/トークA愛/福岡藤次1.jpg",
  	  comment: "怪しい福岡孝悌（藤次）",
  	  items: [
  	    "また後藤と同じ土佐藩参政の要職にあった福岡孝悌（藤次）は、公議政体論者で、龍馬の下宿近江屋の二軒隣に家を借り、龍馬とも親しく接していました。",
  	    "実は事件当日の午後、龍馬は福岡の下宿を訪ね、不在であったため、居合わせたお嘉代（かよ、後の福岡夫人）に近江屋に遊びに来るよう誘いますが、なぜか福岡の従者が止めています。",
  	    "その夜、福岡が帰宅すると、すでに龍馬は殺害されていました。",
  	    "しかし「坂本が殺された時、隣に福岡が下宿していたが見舞いもしなければ会葬もしない。",
  	    "どうも彼の気が知れない」と陸援隊にいた田中顕助（たなかけんすけ）が語っています。",
  	    "そのことをお嘉代が問うと、福岡は「お前の知ったことか」と激怒しました。",
  	    "この福岡の不可解な態度は何を意味するのでしょうか。",
  	    "そして事件当日に「新選組のしわざであろう」と日記に記した土佐藩側用役の寺村左膳。",
  	    "彼も公議政体論の支持者ですが、日記にこう書いています。",
  	    "「龍馬も中岡もこうした時勢なので藩は寛大にも黙認しているが、もともと脱藩者であり、いまだ復籍もしていないので、今回の事件について藩は表向き何ら関知しない」。",
  	    "龍馬も中岡も脱藩の罪はすでに赦免されていたはずですが、寺村は復籍していないとし、事件についてもはなはだ冷淡な態度です。",
  	  ],
  	  pres: [],
  	 },// end of id=2
  	 {id: "3",
  	  title: "坂本龍馬は、福岡孝悌（藤次）の命令で「お嘉代」に毒殺された？",
  	  image: "http://www.hiroict.com/files/talkai/Pictures/トークA愛/坂本龍馬京都1.gif",
  	  comment: "当時の京都の地図",
  	  items: [
  	    "福岡孝悌（藤次）は、海援隊の連中を京都東山にある「噲々樓（かいかいろう）」に招き酒を飲ませていた。",
  	    "この時、お酌をしていたのが、お嘉代（かよ、後の福岡夫人）であった。お嘉代は「山猫」と呼ばれていたらしい。。",
  	    "坂本龍馬が殺された慶応3年11月15日（1867年12月10日）は、坂本龍馬の誕生日であった。",
  	    "すると、この日は福岡孝悌（藤次）が坂本龍馬の誕生日パーティとして近江屋に坂本龍馬や中岡慎太郎らを呼んだ可能性が高い。",
  	    "福岡孝悌（藤次）の命令で、お嘉代が、近江屋の坂本龍馬と中岡慎太郎に毒を盛った可能性が高い。",
  	    "お嘉代は、このご褒美と口封じのために、この後、福岡孝悌（藤次）の第二夫人になった。",
  	    "勿論、坂本龍馬と中岡慎太郎の殺害命令は、上司の後藤象二郎から福岡孝悌（藤次）に出されていた。",
  	    "後藤象二郎は、上司の前土佐藩藩主の山内容堂から命令され、山内容堂は、薩摩藩（西郷隆盛）とその後ろにいる英国のパークス公使やアーネストサトウに命令されていた。",
  	  ],
  	  pres: [],
  	 },// end of id=3
  	 {id: "4",
  	  title: "鬼塚英昭「日本の本当の黒幕」に書かれた坂本龍馬暗殺犯",
  	  image: "",
  	  comment: "",
  	  items: [
  	    "龍馬が著した「閑愁録」（キリスト教で支配される危機感を綴った）に端を発している。",
  	    "これを知ったイギリス公使パークス、外交官アーネストサトウ、長崎で布教していたフルベッキ等が、龍馬暗殺を計画した。",
  	    "島津久光に「暗殺命令」を下し、西郷隆盛、大久保利通が動く。",
  	    "これを受けて薩摩藩士吉井幸輔（パークスのエージェント）が、土佐藩山内容堂、後藤象二郎に訴える。",
  	    "隠れキリシタンでもあった、容堂は、「龍馬のみならず、中岡慎太郎も消せ」と後藤象二郎に指示。",
  	    "後藤象二郎から、福岡孝悌、谷干城、に具体的なプランが指示されて、実動隊は、谷干城、田中光顕、陸奥宗光となった。",
  	  ],
  	  pres: [],
  	 },// end of id=4
  	 {id: "5",
  	  title: "「閑愁録」に書かれたキリスト教の悪口とは",
  	  image: "",
  	  comment: "",
  	  items: [
          "まさに今、西洋のキリスト教が開港された長崎や箱館や浦賀の三港において盛んに信仰されており、キリスト教の神父は絶対神の堂（天主堂）を建て、多くの愚かな民衆を惑わしている。",
          "特に長崎に於いてはそれが最も盛んである。",
          "最近、長崎の浦上や大浦の村民が競ってキリスト教の信者になり、合計すれば三千人に及んでいる。",
          "・・",
          "そのキリスト教の説く教えとは、神の教えを信じれば、救われる。",
          "そのような教えであるから、民法や刑法で取り締まり、刑罰を与えるとして禁止しても効果はない。"
        ],
  	  pres: [],
  	 },// end of id=5
  	],
  }

  private tabGroup: {
    "font-weight": "bold",
    "background": "#eee",
    "color": "red",
  };
  private isLarge: true;
  private isRed: true;
  private isUnderLine: true;
  private test: string;
  private isActive = "1";
  //private isActive: boolean[] //= [true, false, false, false] ;
  //private isActive0: boolean;
  //private isActive1: boolean;
  //private isActive2: boolean;
  //private isActive3: boolean;
  private color: "red";
  /*
  classObject: {
    isRed: true,
    'is-active': true
  }
  */
  /** ライフサイクルフック */
  public created() {
    window.console.log("created() 1.");
    this.isActive = "1";
    this.test = "test";
    //this.albums = [this.album_2, this.album_1];
    //this.firstImage();
  }

  // タブ切り替え
  private selectTab(index: number): void {
    window.console.log("selectTab() 1.index: " + index);
    this.isActive = "2";
    this.test = "test2";
    window.console.log("selectTab() 2.this.isActive: " + this.isActive);
  }

  private testProc() {
    this.isActive = "2";
    window.console.log("test() 1.this.isActive: " + this.isActive);
  }

  classObject() {
    return {
      isRed: this.isRed,
      "is-Active": this.isActive
    };
  }
} // end of export
